export type Testimonial = {
  /** The customer's own words. Never edited into marketing language. */
  quote: string
  /** First name + last initial is enough. Only what she agreed to. */
  author: string
  /** One line of context, e.g. "mom of four, third year homeschooling". */
  context: string
  /** Square photo URL. Omit it and the card falls back to a monogram. */
  photo?: string
}

/**
 * ⚠️ PLACEHOLDER TESTIMONIALS — DO NOT PUBLISH OR RUN ADS WITH THESE.
 *
 * Everything below is written copy, not a real customer, and every photo is a
 * generated image, not a real person. It exists so the two testimonial
 * sections can be reviewed in place, and so the pilot cohort's real quotes and
 * photos have a shape to drop into. Publishing a generated face beside an
 * invented quote is the single riskiest thing on this page.
 *
 * Before launch, either:
 *   a) replace every entry with a real buyer's words (with her permission), or
 *   b) empty both arrays — the page then falls back to the honest substitutes
 *      ("No testimonials yet…" and the twenty-minute scene) automatically.
 *
 * One invented quote on a $27 product with no track record costs more than all
 * of them earn.
 */

/** Section 3 — mirrors the three core promises: stopped restarting, survived a
 *  hard season, records stopped causing dread. */
export const firstRun: Testimonial[] = [
  {
    quote:
      'I have four abandoned planners in a drawer. This is the first thing I have not restarted. Week three came and went and I did not notice, which is the whole point.',
    author: 'Sarah M.',
    context: 'mom of four, third year homeschooling',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/1d47a21d-7696-4284-96cb-ca07b072d4cc.jpg',
  },
  {
    quote:
      'We moved in October. Two weeks of nothing. I sat down on a Sunday, ran the reset, and we picked back up on Monday — no rebuilding, no guilt spiral.',
    author: 'Danielle R.',
    context: 'mom of two, moved mid-year',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/d1645949-6ada-4dad-aef6-a5dcb0ec12b0.jpg',
  },
  {
    quote:
      'I used to keep every worksheet because I did not know what counted. Now there are three lines a day and a folder I am not afraid of. I sleep.',
    author: 'Priya K.',
    context: 'mom of three, second year homeschooling',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/50737350-1e65-48fd-8424-35200731714f.jpg',
  },
]

/** Section 12 — validates the price card, so these name specific pieces. */
export const secondRun: Testimonial[] = [
  {
    quote:
      'The Weekly Reset Checklist lives on the fridge and takes about twenty minutes. That one page is doing the work I thought I needed more discipline for.',
    author: 'Megan T.',
    context: 'mom of two, fifth year homeschooling',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/811eaffa-4c5d-430e-aa40-dc5fc707f93f.jpg',
  },
  {
    quote:
      'My six-year-old runs her own routine card now. She does not ask me what is next anymore, and nothing on the card says her age or her level.',
    author: 'Bethany S.',
    context: 'mom of three, first year homeschooling',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/8e84de8f-e5c4-4bc9-bc94-4a1d32f56ca4.jpg',
  },
  {
    quote:
      'The Simplify Ladder is the reason we did not quit in February. I cut down two rungs for six weeks instead of dropping the whole thing.',
    author: 'Carla V.',
    context: 'mom of five, seventh year homeschooling',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/9ecf2e42-8f56-41a8-bfdc-14504f20bdec.jpg',
  },
]
